import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Address } from "components/Address/Address";
import { Button } from "components/Button/Button";
import { DataGrid } from "components/DataGrid/DataGrid";
import { DictionarySelectBox } from "components/DictionaryTypeSelect/DictionaryTypeSelect";
import { FormWithTitle } from "components/FormWithTitle/FormWithTitle";
import { Headerbar } from "components/Headerbar/Headerbar";
import { Loading } from "components/Loading/loading";
import { Message } from "components/Message/Message";
import { ModalForm } from "components/ModalForm/ModalForm";
import { Person } from "components/Person/Person";
import { Textbox } from "components/Textbox/Textbox";
import { Toast } from "components/ToastShow/ToastAlert";
import { LayoutContext } from "layouts/DashboardLayout/context/LayoutContext";
import { AddressBox } from "pages/InventoryAndSales/Sales/SalesInvoice/components/AddressBox/AddressBox";
import { CustomerPhoneDictionary } from "pages/InventoryAndSales/Sales/SalesInvoice/components/CustomerPhoneDictionary/CustomerPhoneDictionary";
import { CustomerPhoneList } from "pages/InventoryAndSales/Sales/SalesInvoice/components/CustomerPhones/CustomerPhoneList";
import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ICON_TYPE, INVENTORYANDSALES_URL } from "utils/constants";
import { ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { convertAddress, RoundOutputOperation, RoundWithRoundingPlace, trans, uuidv4 } from "utils/helpers";
import { getDefaultPersonContact, getSalesOrderById, sendBasketAsync,getOrderConstraint } from "./api";
import { CustomerSalesOrderDetailForm } from "./CustomerSalesOrderDetailForm";
import { ContactType, MessageType } from "types/enum";
import { PriceInput } from "components/PriceInput/PriceInput";

interface CustomerSalesOrderProps {
  onHide: () => void;
  mode?: any;
  basketData: any;
  processId?: any;
  useClient?: any;
  Id?:any,
  callAttachmentMoveTemp?:any
}

export const CustomerSalesOrder = ({
  basketData,
  onHide,
  mode,
  processId,
  useClient,
  Id,
  callAttachmentMoveTemp
}: CustomerSalesOrderProps) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [resetForm, setResetForm] = useState<boolean>(false);
  const [response, setResponse] = useState<any>();
  const [todayDate, settodayDate] = useState<string | null>(
    new Date().toISOString()
  );
  const [customer, setCustomer] = useState<any>(null);
  const [selectedPhoneDetail, setSelectedPhoneDetail] = useState<any>({
    phone:'',
    mobile:''
      });

  const [customerInfo, setCustomerInfo] = useState<any>(null);
  const [showCustomerPhoneForm, setShowCustomerPhoneForm] = useState(false);

  const [showAddressBox, setShowAddressBox] = useState<
    "createMode" | "selectMode" | null
  >(null);
  const [detailMode, setDetailMode] = useState<"create" | "edit" | "view">(
    mode
  );

  const [showForm, setShowForm] = useState(false);
  const [selectedObj, setSelectedObj] = useState<any>(null);
  const [salesOrderDetail, setSalesOrderDetail] = useState<any>([]);
  const [dataGridLoading, setDataGridLoading] = useState<any>(true);
  const [totalRows, setTotalRows] = useState<any>({
    ItemCount: 0,
    TotalTax: 0,
    TotalDiscount: 0,
    SubTotalPrice: 0,
  });
  const layoutContext = useContext(LayoutContext);
  const [OrderConstraint, setOrderConstraint] = useState<any>({});
  const [payment, setPayment] = useState<any>({ TotalPrice: 0, Prepayment: 0 });
  const [typePhoneContact, setTypePhonContact] = useState<any>();
  const [receive, setReceive] = useState<any>({
    GrandTotalPrice: 0,
    Prepayment: 0,
  });
  const [lastWarehouse, setLastWarehouse] = useState<any>(null);
  const [changeAddress, setChangeAddress] = useState<any>();
  const [person, setPerson] = useState<any>(null);
  const formRef=useRef<any>(null)

  const [requiredFields,setRequiredFields]=useState<any>()
  let IsFiscal = (mode == "create" ? ( OrderConstraint.IsFiscal) :response?.GrandTotalPrice )

  const selectedObjCallback = (obj, index) => {
    setSelectedObj(obj);
  };
  async function getOrderConstraintAsync(withLoading = false) {
    if (withLoading) setLoading(false);
    try {
      const res = await getOrderConstraint();
      setOrderConstraint(res.Data);
      setRequiredFields(res.Data.RequiredFields?JSON.parse(res.Data.RequiredFields):null)
    } catch (error) {}
    if (withLoading) setLoading(true);
  }

  function setSalesOrderDetailHandler(data) {
    setDataGridLoading(false);
    setSalesOrderDetail(data);
    setDataGridLoading(true);
  }

  const handlesetPriceListDetail = (newObj) => {
    if (OrderConstraint.AllowDuplicateItems || detailMode == "edit") {
    setTotalRows({
      ItemCount:
      detailMode == "create"
          ?RoundOutputOperation( totalRows.ItemCount + +newObj.Qty)
          : RoundOutputOperation(totalRows.ItemCount + (+newObj.Qty - +selectedObj.Qty)),
      TotalTax:
      !OrderConstraint.IsFiscal?0:  detailMode == "create"
          ? totalRows.TotalTax + +newObj.Tax
          : totalRows.TotalTax + (+newObj.Tax - +selectedObj.Tax),
      TotalDiscount:
      !OrderConstraint.IsFiscal?0:  detailMode == "create"
          ? totalRows.TotalDiscount + +newObj.Discount
          : totalRows.TotalDiscount +
            (+newObj.Discount - +selectedObj.Discount),
      SubTotalPrice:
      !OrderConstraint.IsFiscal?0:   detailMode == "create"
          ? totalRows.SubTotalPrice + +newObj.SubTotalPrice
          : totalRows.SubTotalPrice +
            (+newObj.SubTotalPrice - +selectedObj.SubTotalPrice),
    });
           setPayment((e)=>{return  {
           ...e,
        TotalPrice:detailMode == "create"
            ? payment.TotalPrice + +newObj.TotalPrice 
            : payment.TotalPrice +
              (+newObj.TotalPrice - +selectedObj.TotalPrice),
      }} );
    if (detailMode == "create") {
      setSalesOrderDetailHandler([...salesOrderDetail, newObj]);
    } else {
      let newItemes = salesOrderDetail.map((item: any) => {
          if (item.Id == newObj.Id) {
            return newObj;
            
          }
           else if((newObj.Id.replace("changeId","")==item.Id )){
                        return {...newObj , Id: uuidv4()};
                      }
          else return item;
        });
      setSalesOrderDetailHandler(newItemes);
    }
    Toast("msg_saveddatasuccessfully", MessageType.success);
    return true
  }

else {
      let Dupli = salesOrderDetail.find((e: any) => e.ItemId == newObj.ItemId);
      if (!Dupli || salesOrderDetail.length == 0) {
        setTotalRows({
          ItemCount:
            detailMode == "create"
              ? RoundOutputOperation(totalRows.ItemCount + +newObj.Qty)
              : RoundOutputOperation(totalRows.ItemCount + (+newObj.Qty - +selectedObj.Qty)),
          TotalTax:
          OrderConstraint.HasTax?
            detailMode == "create"
              ? totalRows.TotalTax + +newObj.Tax
              : totalRows.TotalTax + (+newObj.Tax - +selectedObj.Tax):0,
          TotalDiscount:
            detailMode == "create"
              ? totalRows.TotalDiscount + +newObj.Discount
              : totalRows.TotalDiscount +
                (+newObj.Discount - +selectedObj.Discount),
          SubTotalPrice:
            detailMode == "create"
              ? totalRows.SubTotalPrice + +newObj.SubTotalPrice
              : totalRows.SubTotalPrice +
                (+newObj.SubTotalPrice - +selectedObj.SubTotalPrice),
        });
               setPayment((e)=>{return  {
           ...e,
        TotalPrice:detailMode == "create"
            ? payment.TotalPrice + +newObj.TotalPrice 
            : payment.TotalPrice +
              (+newObj.TotalPrice - +selectedObj.TotalPrice),
      }} );
        if (detailMode == "create") {
          setSalesOrderDetailHandler([...salesOrderDetail, newObj]);
        } else {
          let newItemes = salesOrderDetail.map((item: any) => {
          if (item.Id == newObj.Id) {
            return newObj;
            
          }
           else if((newObj.Id.replace("changeId","")==item.Id )){
                        return {...newObj , Id: uuidv4()};
                      }
          else return item;
        });
          setSalesOrderDetailHandler(newItemes);
        }
        // Toast("msg_saveddatasuccessfully", "success");
        Toast("msg_saveddatasuccessfully", MessageType.success);
        return true;
      } else {
        // Toast("msg_duplicateitems", "error");
        Toast("msg_duplicateitems", MessageType.error);

        return false;
      }
    }
};
  async function getDefaultPersonContactAsync() {
    try {
      // const res2 = await getPersonCustomer(personId)
      const res = await getDefaultPersonContact(
        layoutContext.currentUserPosition.PositionId
      );
      setCustomerInfo({ ...res.Data });
    } catch (error) {}
  }
  const navigate = useNavigate();
  const handleCustomerSalesOrderFormSubmit = async (event) => {
    event.preventDefault();
    let SalesOrderDetails: any = [];
    
    if (processId || useClient) {
    salesOrderDetail.map((item) => {
    SalesOrderDetails.push({
          ItemId: item.ItemId,
          Qty: item.Qty,
          UnitId: item.UnitId,
          Description: item.Description,
          WarehouseId:item.WarehouseId,
          WarehouseDetailId:item.WarehouseDetailId??null,
        });
      });
    } else {
      salesOrderDetail.map((item) => {
        SalesOrderDetails.push({
          ItemId: item.ItemId,
          Qty: item.Qty,
          UnitId: item.UnitId,
          Description: item.Description,
          WarehouseId:item.WarehouseId,
          WarehouseDetailId:item.WarehouseDetailId??null,
        });
      });
    }

    let data = {
      CustomerName: customer?.Name
        ? customer?.Name
        : layoutContext.currentUserPosition.PersonDescription	,
      CustomerPhone: customer?.CustomerPhone?.Name.split(":")[1]?customer?.CustomerPhone?.Name.split(":")[1] :customer?.CustomerPhone?.Name??null,
      CustomerMobilePhone: customer?.CustomerMobilePhone?.Name.split(":")[1]?customer?.CustomerMobilePhone?.Name.split(":")[1] :customer?.CustomerMobilePhone?.Name??null,
      CustomerAddress: formRef.current.Address?.value??null,
      CustomerEconNo: formRef.current.CustomerEconNo?.value,
      CustomerNationalCode: formRef.current.CustomerNationalCode?.value,
      SalesOrderDate: todayDate,
      Description: formRef.current.Description.value,
     // PaymentMethodId: formRef.current.PaymentMethodId?.value,
      SalesOrderDetails: SalesOrderDetails,
      RecipientPersonId: person?.Id ? person.Id : null,
      RecipientPersonDescription: person?.Name ? person.Name : null,
    };

    try {
      const res=await sendBasketAsync(data, "post");
                  if(res.Data){

        callAttachmentMoveTemp &&   callAttachmentMoveTemp(res.Data)
        }
      onHide();
      if (!(processId || useClient)) {
        localStorage.removeItem("Basket");
        navigate("/e-commerce/Items");
      }
    } catch (error) {}
  };




  async function makeOrderFromBasket() {
    setLoading(false);
    try {
      //  await getOrderConstraintAsync();
      let SalesOrderDetails: any = [];
      let priceData = {
        TotalTax: 0,
        TotalDiscount: 0,
        SubTotalPrice: 0,
        TotalPrice: 0,
        Prepayment: 0,
        GrandTotalPrice: 0,
      };
      let count = 0;
      basketData.map((items) => {
        Object.values(items.order).map((orders: any) => { 
          const discount=RoundWithRoundingPlace(orders.OrderItemId.SalesUnitDiscount * +orders.count,orders.OrderItemId.PriceRoundingPlace)
const customerDiscount=RoundWithRoundingPlace(orders.OrderItemId.CustomerDiscount*+orders.count,orders.OrderItemId.PriceRoundingPlace)
const totalDiscount=discount+customerDiscount
const tax=RoundWithRoundingPlace(orders.OrderItemId.SalesUnitPrice==-1?0:
RoundWithRoundingPlace (( orders.OrderItemId.SalesUnitPrice*+orders.count) - totalDiscount,orders.OrderItemId.PriceRoundingPlace) *

           ( (items?.TaxObject?.[orders?.OrderItemId?.ItemId]??0)/100),orders.OrderItemId.PriceRoundingPlace)
       
          count += +orders.count;
          priceData.TotalDiscount +=
           totalDiscount;
          priceData.SubTotalPrice +=orders.OrderItemId.SalesUnitPrice==-1?0:
            orders.OrderItemId.SalesUnitPrice * +orders.count;
          priceData.TotalPrice +=orders.OrderItemId.SalesUnitPrice==-1?0:
            (orders.OrderItemId.SalesUnitPrice * +orders.count
            )-totalDiscount
      
          priceData.TotalTax +=orders.OrderItemId.SalesUnitPrice==-1?0: (orders.OrderItemId.SalesUnitPrice -
            orders.OrderItemId.SalesUnitDiscount) *
          +orders.count*(items?.TaxObject?.[orders?.OrderItemId?.ItemId]??0)/100


priceData.GrandTotalPrice+=orders.OrderItemId.SalesUnitPrice==-1?0:
          RoundWithRoundingPlace ( (orders.OrderItemId.SalesUnitPrice*+orders.count) -



totalDiscount
              


              

          
                + 
               
             tax,orders.OrderItemId.PriceRoundingPlace)


          SalesOrderDetails.push({
            Id: uuidv4(),
            SalesOrderId: uuidv4(),
            ItemId: orders.OrderItemId.ItemId,
            UnitId: orders.OrderItemId.SalesUnitId,
            SourceId: null,
            SourceData: null,
            ItemEN: null,
            WarehouseId:orders.WarehouseId,
            WarehouseDetailId:orders.WarehouseDetailId??null,
            UnitEN: null,
            DescriptionEN: null,
            ItemCode: orders.OrderItemId.ItemCode,
            Item: orders.OrderItemId.ItemDescription,
            ItemTechnicalCode: null,
            Qty: +orders.count,
            Unit: orders.OrderItemId.SalesUnit,
            UnitPrice:orders.OrderItemId.SalesUnitPrice,
            SubTotalPrice:orders.OrderItemId.SalesUnitPrice==-1?0: orders.OrderItemId.SalesUnitPrice * +orders.count,
            Discount:discount,
            DiscountPercent: orders.OrderItemId.DiscountPercent,
            CustomerDiscountPercent:orders.OrderItemId.CustomerDiscountPercent,
            CustomerDiscount:customerDiscount,
            TotalPrice:orders.OrderItemId.SalesUnitPrice==-1?0:
        RoundWithRoundingPlace (( orders.OrderItemId.SalesUnitPrice*+orders.count) - totalDiscount,orders.OrderItemId.PriceRoundingPlace)
                ,
            Tax:tax,
            TaxRate:items?.TaxObject?.[orders?.OrderItemId?.ItemId]??0,
            Description: null,
            GrandTotalPrice:orders.OrderItemId.SalesUnitPrice==-1?0:
          RoundWithRoundingPlace ( (orders.OrderItemId.SalesUnitPrice*+orders.count) -



totalDiscount
              


              

          
                + 
               
             tax,orders.OrderItemId.PriceRoundingPlace)
       
          });
        });
      });

  
      

      setSalesOrderDetail(SalesOrderDetails);
      setTotalRows({
        ItemCount: count,
        TotalTax: priceData?.TotalTax,
        TotalDiscount:priceData?.TotalDiscount+((priceData?.TotalPrice)*(layoutContext.layoutEcommrceConstraint?.CustomerDiscount?layoutContext.layoutEcommrceConstraint?.CustomerDiscount:0)/100)  ,
        SubTotalPrice: priceData?.SubTotalPrice,
      });
     
      
      setPayment({
        TotalPrice: priceData?.TotalPrice,
        Prepayment: priceData?.Prepayment,
      });
      setReceive({
        GrandTotalPrice: priceData?.GrandTotalPrice,
        Prepayment: priceData?.Prepayment,
      });
    } catch (error) {}
    setLoading(true);
  }


  async function getOrderAsync() {
    setLoading(false);
    try {
      if(mode!='view'){
        await getOrderConstraintAsync();
      }
      const res = await getSalesOrderById(Id);
      // setSalesOrderNo(res.Data?.SalesOrderNo)
      setResponse(res.Data);
      if(mode=='view'){
        setOrderConstraint({IsFiscal:res.Data.IsFiscal})
      }
      let count = 0;
      res.Data.CustomerSalesOrderDetailViewDTO.map((item) => {
        count += +item?.Qty;
      });
      setSalesOrderDetail(res.Data.CustomerSalesOrderDetailViewDTO);

      setTotalRows({
        ItemCount: count,
        TotalTax:  res.Data?.TotalTax,
        TotalDiscount: res.Data?.TotalDiscount,
        SubTotalPrice: res.Data?.SubTotalPrice,
      });
      setPayment({
        TotalPrice: res.Data?.TotalPrice,
        Prepayment: res.Data?.Prepayment,
      });
      setReceive({
        GrandTotalPrice: res.Data?.GrandTotalPrice,
        Prepayment: res.Data?.Prepayment,
      });
    } catch (error) {}
    setLoading(true);
  }


const handleDeleteRow = async (id: string = selectedObj.Id) => {
    let newPriceListDetail: any = [...salesOrderDetail];
    let obj = newPriceListDetail.filter((e) => e.Id == id)[0];

 setTotalRows({
      ItemCount: RoundOutputOperation(totalRows.ItemCount - +obj.Qty),
      TotalTax: OrderConstraint.HasTax?totalRows.TotalTax - +obj.Tax:0 ,
      TotalDiscount: totalRows.TotalDiscount - +obj.Discount - +obj.CustomerDiscount,
      SubTotalPrice: totalRows.SubTotalPrice - +obj.SubTotalPrice,
    });

    
     setPayment((e)=>{return  {
           ...e,
        TotalPrice:e.TotalPrice - +obj.TotalPrice,
      }} );
    setSalesOrderDetailHandler(newPriceListDetail.filter((e) => e.Id != id));
  };
    useEffect(() => {

      
      setReceive({
        ...receive,
        GrandTotalPrice: +payment.TotalPrice + +totalRows.TotalTax,
      });
    }, [payment]);

  useEffect(() => {
    getDefaultPersonContactAsync();
  }, []);
  useEffect(() => {
    if (basketData && !(processId || useClient)) makeOrderFromBasket();
    if (mode != "create") {
      getOrderAsync();
    } else {
      getOrderConstraintAsync(true);
    }
  }, []);






  return (
    <>
      {showForm ? (
        <ModalForm
          modalHeight={49}
          mode={mode}
          onHide={() => {
            setShowForm(false);
          }}
          show={showForm}
          title={"SalesOrderDetailForm"}
        >
          <CustomerSalesOrderDetailForm
            CustomerSalesWarehouse={OrderConstraint?.EcommerceWarehouseId}
            setLastWarehouse={setLastWarehouse}
            lastWarehouse={lastWarehouse}
            HasWarehouseDetail={OrderConstraint?.HasWarehouseDetail}
            mode={detailMode}
            onHide={() => {
              setShowForm(false);
            }}
            priceList={OrderConstraint?.EcommercePriceListId}
            OrderConstraint={OrderConstraint}
            selectedObj={selectedObj}
            CustomerSalesOrderDetailCallBack={(e) =>
              handlesetPriceListDetail(e)
            }
            personId={layoutContext.currentUserPosition.PersonId}
          />
        </ModalForm>
      ) : (
        <></>
      )}
      {showCustomerPhoneForm ? (
        <ModalForm
          modalHeight={49}
          mode={mode}
          onHide={() => {
            setShowCustomerPhoneForm(false);
          }}
          show={showCustomerPhoneForm}
          title={"CustomerPhoneForm"}
        >
          <CustomerPhoneList
            Current={true}
            personId={customer?.Id}
            CustomerPositionId={
              layoutContext.currentUserPosition.PositionId
            }
            onHide={() => {
              setShowCustomerPhoneForm(false);
            }}
            type={typePhoneContact}
            handlePhone={(e) => {
              typePhoneContact==ContactType.Phone?setSelectedPhoneDetail({...selectedPhoneDetail, phone:e}):setSelectedPhoneDetail({...selectedPhoneDetail, mobile:e})
            }}
          />
        </ModalForm>
      ) : (
        <></>
      )}
      {showAddressBox ? (
        <ModalForm
          modalHeight={49}
          onHide={() => {
            setShowAddressBox(null);
          }}
          mode={mode}
          show={showAddressBox && true}
          title={"Address"}
        >
          <AddressBox
            Current={true}
            personId={customer?.Id}
            CustomerPositionId={layoutContext.currentUserPosition.PositionId}
            onHide={() => {
              setShowAddressBox(null);
            }}
            status={showAddressBox}
            AddressHandeler={(e) => {
              setCustomerInfo({
                ...customerInfo,
                Address: JSON.stringify(e).toLowerCase(),
              });
              setShowAddressBox(null);
            }}
          />
        </ModalForm>
      ) : (
        <></>
      )}
      <div className="person-contact-form card">
        <div className="card-body">
          {loading ? (
              <form onSubmit={handleCustomerSalesOrderFormSubmit} ref={formRef} >
            <div className="container-fluid">
                <div className="row ">
             
                  {response?.SalesOrderNo &&
                  <div className="col-lg-2">
                    <Textbox
                      textboxType="text"
                      textboxName="salesorderno"
                      labelText="salesorderno"
                      defaultValue={
                        mode==='create'?OrderConstraint?.DocNo:
                        response?.SalesOrderNo ? response?.SalesOrderNo : ""
                      }
                      resetForm={resetForm}
                      mode={"view"}
                    />
                  </div>
                  
                  }
                  <div className="col-lg-2">
                    <Textbox
                      textboxType="text"
                      textboxName="CustomerName"
                      labelText="CustomerName"
                      defaultValue={
                        response?.CustomerName
                          ? response?.CustomerName
                          : layoutContext.currentUserPosition.PersonDescription
                      }
                      resetForm={resetForm}
                      mode={"view"}
                    />
                  </div>
                  <div className="col-lg-2 ">
                    <Textbox
                      textboxType="text"
                      textboxName="CustomerEconNo"
                      labelText="CustomerEconNo"
                      defaultValue={
                        response?.CustomerEconNo
                          ? response?.CustomerEconNo
                          : customerInfo?.EconNo
                      }
                      resetForm={resetForm}
                      mode={mode}
                      required={requiredFields?.CustomerEconNo}
                    />
                  </div>
                  <div className="col-lg-2">
                    <Textbox
                      textboxName="CustomerNationalCode"
                      textboxType="nationalCode"
                      labelText="CustomerNationalCode"
                      defaultValue={
                        response?.CustomerNationalCode
                          ? response?.CustomerNationalCode
                          : customerInfo?.NationalId
                      }
                      resetForm={resetForm}
                      mode={mode }
                      required={requiredFields?.CustomerNationalCode}
                    />
                  </div>

                  <div className="col-12 col-lg-2 d-flex">
                  <div className="flex-grow-1">
                  <CustomerPhoneDictionary
                  Current={true}
                    required={requiredFields?.CustomerPhone}
                    type={ContactType.Phone}
                    name="CustomerPhone"
                    label="CustomerPhone"
                    resetForm={resetForm}
                    valueString={
                      selectedPhoneDetail.phone?.Value?selectedPhoneDetail.phone?.Value: response?.CustomerPhone || mode !== "create"
                        ? response?.CustomerPhone
                        :customerInfo?.PhoneNumber
                    }
                    mode={mode }
                    returnObj={true}
                    CustomerPositionId={
                      response?.CustomerPositionId
                        ? response?.CustomerPositionId
                        : layoutContext.currentUserPosition.PositionId
                    }
                    onChange={(e) => {
                      setCustomer((prev)=>{return{ ...prev, CustomerPhone: e }});
                    }}
                  />
                  </div>
               
                {mode != "view" && (
                  <div
                    style={{
                      marginTop: "25px",
                      width: "1%",
                      // marginRight: "-25px",
                    }}
                    className="ms-4"
                  >
                    <Button
                      Icon={true}
                      value={
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            setShowCustomerPhoneForm(true);
                            setTypePhonContact(ContactType.Phone);
                          }}
                          className="checkButton d-flex align-items-center justify-content-center"
                        >
                          <FontAwesomeIcon
                            icon={[ICON_TYPE, "plus"]}
                            size="2x"
                          />
                        </button>
                      }
                      btnType="primary"
                    />
                  </div>
                )}
                </div>
                <div className="col-12 col-lg-2 d-flex">
                  <div className="flex-grow-1">

                  <CustomerPhoneDictionary
                  Current={true}
                    required={requiredFields?.CustomerMobilePhone}
                    type={ContactType.Mobile}
                    name="CustomerMobilePhone"
                    label="CustomerMobilePhone"
                    resetForm={resetForm}
                      valueString={
                        selectedPhoneDetail.mobile?.Value?selectedPhoneDetail.mobile?.Value:
                         response?.CustomerMobilePhone || mode !== "create"
                          ? response?.CustomerMobilePhone
                          :customerInfo?.MobilePhone
                      }
                    mode={mode }
                    returnObj={true}
                    CustomerPositionId={
                      response?.CustomerPositionId
                        ? response?.CustomerPositionId
                        : layoutContext.currentUserPosition.PositionId
                    }
                    onChange={(e) => {
                      setCustomer((prev)=>{return{ ...prev, CustomerMobilePhone: e }});

                    }}
                  />
                  </div>
                {mode != "view" && (
                  <div
                    style={{
                      marginTop: "25px",
                      width: "1%",
                      // marginRight: "-25px",
                    }}
                    className="ms-4"
                  >
                    <Button
                      Icon={true}
                      value={
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            setShowCustomerPhoneForm(true);
                            setTypePhonContact(ContactType.Mobile);
                          }}
                          className="checkButton d-flex align-items-center justify-content-center"
                        >
                          <FontAwesomeIcon
                            icon={[ICON_TYPE, "plus"]}
                            size="2x"
                          />
                        </button>
                      }
                      btnType="primary"
                    />
                  </div>
                )}
                </div>
        
                  <div className="col-lg-2">
                    <Person
                      value={response?.RecipientPersonId}
                      resetForm={resetForm}
                      mode={mode}
                      WithSearch={false}
                      setPerson={setPerson}
                      returnObj={true}
                      name={"RecipientPersonDescription"}
                      label="receiverperson"
                      required={requiredFields?.RecipientPersonId}
                      valueString={response?.RecipientPersonDescription}

                    />
                  </div>
                  {/* <div className="w-100"></div>
                  <div className="col-lg-5 col-11 row">
                  <Address onChange={(e)=>{setShowAddressBox('selectMode');return false}} withMap={false} hideDetail={true} personContact={
                             response?.CustomerAddress?response?.CustomerAddress:''}mode={"view"}/>   

                  </div> */}

                  <div className="col-lg-5 col-12 mt-2 mt-lg-0 d-flex ">
                    <div className="flex-grow-1">
                      <Address
                        onChange={(e) => {
                          setShowAddressBox("selectMode");
                          return false;
                        }}
                        withMap={false}
                        hideDetail={true}
                        personContact={
                          changeAddress
                            ? convertAddress(changeAddress)
                            : response?.CustomerAddress
                            ? response?.CustomerAddress
                            : convertAddress(customerInfo?.Address)
                        }
                        mode={"view"}
                        required={requiredFields?.CustomerAddress}
                      />
                    </div>

                    {mode != "view" && (
                      <>
                        <div
                          style={{
                            marginTop: "25px",
                            width: "1%",
                            // marginRight: "-25px",
                          }}
                          className="ms-4"
                        >
                          <Button
                            Icon={true}
                            value={
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  setShowAddressBox("createMode");
                                }}
                                className="checkButton d-flex align-items-center justify-content-center"
                              >
                                {" "}
                                <FontAwesomeIcon
                                  icon={[ICON_TYPE, "plus"]}
                                  size="2x"
                                />
                              </button>
                            }
                            btnType="primary"
                          />
                        </div>
                      { mode!=='view' && <div
                          style={{
                            marginTop: "25px",
                            width: "1%",
                            // marginRight: "5px",
                            marginLeft: "20px",
                          }}
                          className="ms-4"
                        >
                          <Button
                            Icon={true}
                            value={
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  setShowAddressBox("selectMode");
                                }}
                                className="checkButton d-flex align-items-center justify-content-center"
                              >
                                {" "}
                                <FontAwesomeIcon
                                  icon={[ICON_TYPE, "search"]}
                                  size="2x"
                                />
                              </button>
                            }
                            btnType="primary"
                          />
                        </div>}
                      </>
                    )}
                  </div>

                  <div className="col-lg-6 ">
                    <Textbox
                      textboxType="textarea"
                      textboxName="Description"
                      labelText="Description"
                      defaultValue={response?.Description}
                      maxLength={900}
                      resetForm={resetForm}
                      mode={mode}
                      required={requiredFields?.Description}
                    />
                  </div>
                </div>
                <>
                  <div className="mt-3">
                    <FormWithTitle title={trans("Details")}>
                      <div>
                        <div className="row justify-content-between">
                          {mode != "view" && (
                            <div
                              onClick={() => {
                                setDetailMode("create");
                                setShowForm(true);
                              }}
                              className="col-2 mb-1 btn btn-success btn-sm d-flex align-items-center justify-content-between "
                              style={{
                                width: "70px",
                                maxHeight: "30px",
                                marginRight: "20px",
                                minWidth: "70px",
                              }}
                            >
                              <>
                                <span className=" font-size-md ms-2 ">
                                  {trans("add")}
                                </span>
                                <FontAwesomeIcon
                                  size="xs"
                                  icon={["fas", "plus"]}
                                  className="color_text_light d-flex Requests__chatbox-reply-btn mx-1 p-1"
                                  color="white"
                                />
                              </>
                            </div>
                          )}
                          <div
                            className={`${
                              mode != "view" ? "col-10" : "col-12 "
                            } row `}
                          >
                            <div className="d-flex justify-content-end align-items-center">
                              <div className="col-12 col-lg-8 row justify-content-end mb-1">
                                <Headerbar
                                  withPading={false}
                                  headerContents={OrderConstraint.HasTax? totalRows : {...totalRows,TotalTax:0}}
                                  hasBorder={true}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        {dataGridLoading ? (
                          <>
                            {(mode=="view" ? salesOrderDetail?.length > 0 :(OrderConstraint?.DetailDTO &&mode!="view")||(salesOrderDetail?.length > 0&&mode=="view")) ? (
                              <>
                                <DataGrid
                                useLanguage={true}
                                  convertDateColNames={["ExpireDate"]}
                                  DoubleClick={(e) => {
                                    setSelectedObj(e);
                                    setDetailMode(mode=="create" ?"edit":mode);
                                    setShowForm(true);
                                  }}
                                  defaultValueOption={{ "-1": OrderConstraint?.ItemNoPriceText?OrderConstraint?.ItemNoPriceText:'' }}
                                  parentName={"SalesOrderDetailList"}
                                  startIndex={8}
                                  theadData={mode!=='view'?Object.keys(OrderConstraint?.DetailDTO):Object.keys(salesOrderDetail?.[0])}
                                  tbodyData={
                                    salesOrderDetail?.length > 0
                                    ? salesOrderDetail
                                    : [OrderConstraint.DetailDTO]
                                  }
                                  totalRecords={
                                    salesOrderDetail?.length > 0 ? undefined : 0
                                  }
                                  scrollHeight={"67vh"}
                                  minCellWidth={80}
                                  selectedRowObjectCallback={
                                    selectedObjCallback
                                  }
                                  handleEdit={
                                    mode != "view"
                                      ? (e) => {
                                          setSelectedObj(e);
                                          setDetailMode("edit");
                                          setShowForm(true);
                                        }
                                      : undefined
                                  }
                                  handleDelete={
                                    mode != "view"
                                      ? (e) => {
                                          // Toast(
                                          //   trans("msg_deleteconfirm"),
                                          //   "warning",
                                          //   "alert",
                                          //   () => handleDeleteRow(e)
                                          // );
                                          Toast(
                                            trans("msg_deleteconfirm"),
                                           MessageType.confirmDelete,
                                            () => handleDeleteRow(e)
                                          );
                                        }
                                      : undefined
                                  }
                                  rowSelected={selectedObj}
                                  handleView={(e) => {
                                    setSelectedObj(e);
                                    setDetailMode("view");
                                    setShowForm(true);
                                  }}
                                />
                              </>
                            ) : (
                              <Message
                                message={"NoDataForPreview"}
                                type={"info"}
                              />
                            )}
                          </>
                        ) : (
                          <Loading />
                        )}
                      </div>
                    </FormWithTitle>
                  
                  </div>

                  <div className="card">
                    <div className="card-body ">
                      <div className="row">
                        <div className="col-lg-2">
                          {/* <Textbox
                            useGroupingPrice={true}
                            textboxName="GrandTotalPrice"
                            round={OrderConstraint.FloorTaxDuty}
                            textboxType="text"
                            labelText="GrandTotalPrice"
                            defaultValue={
                              payment.TotalPrice != 0
                                ? payment.TotalPrice + ""
                                : response?.TotalPrice
                                ? response?.TotalPrice + ""
                                : payment.TotalPrice
                            }
                            resetForm={resetForm}
                            mode={"view"}
                          /> */}
                        <PriceInput
                        name="GrandTotalPrice"
                       
                        round={OrderConstraint.FloorTaxDuty}
                        label="GrandTotalPrice"
                        defaultValue={
                          receive?.GrandTotalPrice != 0
                            ? receive?.GrandTotalPrice + ""
                            : response?.GrandTotalPrice
                            ? response?.GrandTotalPrice + ""
                            : receive?.GrandTotalPrice
                        }
                        resetForm={resetForm}
                        mode={"view"}
                      />
                        </div>
{/*                         <div className="col-lg-2">
                    <DictionarySelectBox
                      label="PaymentMethod"
                      name="PaymentMethodId"
                      baseUrl={INVENTORYANDSALES_URL}
                      endPoint={
                        ENDPOINTSINVENTORYANDSALES.Sales
                          .BaseDefinitionAndSetting.PaymentMethod.dictionary
                      }
                      resetForm={resetForm}
                      value={response?.PaymentMethodId}
                      mode={mode}
                    />
                  </div> */}
                      </div>
                    </div>
                    <div className="col-lg-12  my-2 btns_form">
                  {mode != "view" && (
                    <>
                      <Button value="send" disabled={!salesOrderDetail.length} btnType="submit" />
                      <Button
                        btnType="cancel"
                        value="Cancel"
                        onClick={() => {
                          onHide();
                        }}
                      />
                    </>
                  )}
                </div>
                  </div>
                </>
            </div>
            </form>
          ) : (
            <Loading />
          )}
        </div>
      </div>
    </>
  );
};
